import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["simple", "complex"]

  connect() {
    // Show simple by default unless complex values are present
    this.showSimple()
  }

  toggle(event) {
    if (this.simpleTarget.classList.contains('hidden')) {
      this.showSimple()
    } else {
      this.showComplex()
    }
  }

  showSimple() {
    this.simpleTarget.classList.remove('hidden')
    this.complexTarget.classList.add('hidden')
  }

  showComplex() {
    this.simpleTarget.classList.add('hidden')
    this.complexTarget.classList.remove('hidden')
  }
} 